var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-help"},[_c('a',{staticClass:"link-face",attrs:{"href":"https://m.me/huddleBR/","target":"_blank"}},[_vm._v("Ajuda")])])}]

export { render, staticRenderFns }